module.exports = __webpack_public_path__ + "img/index.19cad4a4.png";